<template>
  <div class="revitalize">
    <header class="revitalize__header">
      <div class="container flex flex-wrap justify-between items-center">
        <router-link class="logo-wrap flex-no-shrink revitalize__header__logo" :to="{name: 'Home'}">
          <img :src="logoImg" alt="OwlJourney">
        </router-link>
        <scrollactive
        :offset="40"
        :modifyUrl="false"
        :highlightFirstItem="false"
        >
          <div class="md:hidden p-16 cursor-pointer hover:text-blue ease" @click="toggleMenu">
            <i class="owl-menu"></i>
          </div>
          <nav class="hidden md:flex list-reset revitalize__header__nav">
            <a href="#anchor__revitalize__section01" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer">振興五倍券</a>
            <a href="#anchor__revitalize__section02" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer">什麼是奧丁丁揪你？</a>
            <a href="#anchor__revitalize__section03" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer">旅宿推薦</a>
          </nav>
        </scrollactive>
      </div>
    </header>
    <div class="revitalize__body">
      <div class="bg-white mb-24 relative">
        <div class="absolute top-0 left-0 w-full bg-blur z-0 overflow-hidden" :style="`background-image: url('${mobileCover}')`" style="height: 100%">
          <div class="absolute top-0 left-0 w-full bg-mask z-0" style="height: 100%"></div>
        </div>
        <div class="container relative z-0">
          <img class="block md:hidden" :src="mobileCover" alt="revitalize__mobileCover">
          <img class="hidden md:block" :src="desktopCover" alt="revitalize__desktopCover">
        </div>
      </div>
      <div class="bg-white container container__810">
        <div class="py-8 px-16 bg-yellow-lightest rounded my-16">
          <div class="leading-lg"><span class="font-bold">數位五倍券個人綁定時間：</span>2021年9月22日~2022年4月30日，綁定成功後不得變更。</div>
          <div class="leading-lg"><span class="font-bold">數位五倍券共同綁定時間：</span>2021年9月22日~2021年10月1日（須完成個人綁定）</div>
          <div class="leading-lg flex">
            <span class="font-bold whitespace-no-wrap">紙本五倍券預訂方式：</span>
            <div>
              <div>於平台/超商預訂，需透過健保卡/健保快易通(OTP)/自然人憑證</div>
              <div>第一梯次於9/25-10/1預訂，於10/8-10/21領取</div>
              <div>第二梯次於10/25-10/31預訂，於11/8-11/21領取</div>
              <div>於郵局預約領取：10/4起開放預約，並於10/12-10/30領取</div>
            </div>
          </div>
          <div class="leading-lg"><span class="font-bold">數位五倍券共同綁定時間：</span>2021年10月8日~2022年4月30日</div>
        </div>
        <div class="text-sm text-grey-dark leading-lg">更新日期 2021/9/23</div>
        <div class="mb-16">
          <h1 class="text-xl font-bold leading-xl">一站秒懂「振興五倍券」最新資訊及如何使用</h1>
          <p class="text-grey-darker leading-md text-sm">隨著去年(2020)年推出三倍券後，創造很大的經濟效益，今年(2021)推出振興五倍券，整體方案可較去年創造更大的振興效果，秉持著「更好領、更好用、更刺激」三大原則，來讓臺灣邁向新階段。自 9 月 22 日起開放數位五倍券綁定，並於 10 月 8 日正式開始消費累積。每人可換取 5000 元，分為紙本實體券、信用卡、電子票證及行動支付，四種領取方式任你挑選，效期使用至2022年4月30日止。</p>
        </div>
      </div>
      <div>
        <div id="anchor__revitalize__section01" class="faq">
          <div class="container container__810">
            <h3 class="mb-24 font-bold text-green">振興五倍券</h3>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q1</div>
                <div class="text">五倍券是什麼？</div>
              </div>
              <div class="answer">
                <div class="text">政府為了振興經濟，決定將比照去年三倍券模式發放「振興五倍券」，帶動國人消費。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q2</div>
                <div class="text">誰能領五倍券？</div>
              </div>
              <div class="answer">
                <div class="text">本次五倍券全民普發、不排富，2022年4月30日截止前出生的中華民國國民皆可領取（包括新生兒），且具有中華民國國籍的國民、取得永久居留權的外籍人士都可以領取。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q3</div>
                <div class="text">五倍券可以領幾次？</div>
              </div>
              <div class="answer">
                <div class="text">每人僅限領一次。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q4</div>
                <div class="text">五倍券發行形式？</div>
              </div>
              <div class="answer">
                <div class="text">分為紙本券與數位券兩種，紙本券則會發放3張1000元 ，2張500元 ，5張200元，數位券則可分為「行動支付」和「電子票證」，以及「信用卡」等幾種綁定方式。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q5</div>
                <div class="text">五倍券發行時間？</div>
              </div>
              <div class="answer">
                <div class="text">
                  數位綁定：9月22日<br>紙本預約：9月25日(超商、官網)、10月4日(郵局)<br>領取使用：10月8日(數位、超商)、10月12日(郵局)<br>使用期限：111年4月30日前
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q6</div>
                <div class="text">紙本五倍券發放流程</div>
              </div>
              <div class="answer">
                <div class="text">
                  登記時間：<br>
                  第一梯： 9/25~10/1預約，10/8~10/21領取<br>
                  第二梯次：10/25~10/31預約，10/8~10/21領取<br>
                  <div class="border-b border-grey-lighter w-full my-16"></div>
                  <div class="my-8">紙本共有官網、超商事務機、郵局三種登記方式</div>
                  <div class="ml-16 my-8 border border-grey-lighter rounded p-8">
                    <h6 class="text-sm font-bold">1. 超商預訂：簡訊通知原店取</h6>
                    <ul class="list-reset ml-16">
                      <li>第一是「超商預訂」，需攜帶健保卡至四大超商事務機插卡進行預訂，依簡訊通知到原預購之超商領取。</li>
                    </ul>
                  </div>

                  <div class="ml-16 my-8 border border-grey-lighter rounded p-8">
                    <h6 class="text-sm font-bold">2. 官網預訂：8大通路可領</h6>
                    <ul class="list-reset ml-16">
                      <li>第二是透過官網預訂，9月25日起使用讀卡機讀取健保卡，或用健保快易通APP產生驗證碼做身分驗證後，至官網進行線上登記，可選擇於7-11、全家、萊爾富、OK超商、全聯福利中心、美廉社、屈臣氏和康是美等8大通路領取。</li>
                    </ul>
                  </div>

                  <div class="ml-16 my-8 border border-grey-lighter rounded p-8">
                    <h6 class="text-sm font-bold">3. 郵局領：電話、官網、里長都通</h6>
                    <ul class="list-reset ml-16">
                      <li>紙本券第三種領取方式則是郵局，自10月4日起可至中華郵政網站預約，或是撥打 <a href="tel:0800-700-199">0800-700-199</a> 專線電話預約，預約3天後的領券日期。待收到預約領取時段的簡訊通知，10月12日起至所選擇的郵局，持簡訊以及健保卡就可領到紙本數位券。若未進行預約者，第二階段將自11月1日起到明年4月30日開放現場領券和大宗預約領券。大宗預約領券開放6人以上，里長也可以協助里民領取。</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q7</div>
                <div class="text">數位五倍券的綁定的時間與方法？</div>
              </div>
              <div class="answer">
                <div class="text">綁定時間：2021/9/22~2022/4/30<br>
                綁定方式：信用卡、行動支付（如：街口、LINE Pay）、電子票證（如：悠遊卡、一卡通）進入想綁定的銀行，或是支付業者的官網、App，輸入個人資料後就能完成綁定。需要注意的是，今年一旦選擇綁定的業者，就無法再後悔更換。
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q8</div>
                <div class="text">五倍券的使用期限是什麼時候？</div>
              </div>
              <div class="answer">
                <div class="text">2021年10月8日 至 2022年4月30日可都可以用五倍券消費。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q9</div>
                <div class="text">五倍券需要先付1000元嗎？</div>
              </div>
              <div class="answer">
                <div class="text">今年全民都不必支付現金1000元，就可直接領取面額5000元的五倍券。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q10</div>
                <div class="text">為什麼要綁定數位券？</div>
              </div>
              <div class="answer">
                <div class="text">因擔心疫情，使用數位電子支付的民眾也成長不少，另外也有數位加碼新增「家戶綁定」，憑健保卡認證身分，可將全家人的數位券集中在同一人的帳戶內，可一次領取，省去長輩以及未成年子女不方便使用數位券的困擾。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q11</div>
                <div class="text">五倍券可以使用的範圍有哪些？</div>
              </div>
              <div class="answer">
                <div class="text">適用全國實體店家、攤商皆可使用。
                  <ul>
                    <li>飲食：夜市、市場、餐飲業者等。</li>
                    <li>生活：百貨、零售業、書店、婚宴、體育賽事等。</li>
                    <li>觀光：遊樂園與休閒農場等。</li>
                    <li>交通：加油站、高鐵、台鐵、客運與國內線飛機票。</li>
                    <li>旅宿：旅館、飯店、民宿，訂房網站，則須綁定信用卡消費。</li>
                    <li>藝文展演行業：演唱會、兩廳院售票、電影院網站、FamiTicket、ibon、年代售票。</li>
                    <li>繳費：「臨櫃」繳交電信費、瓦斯費、第四台及學雜費或補習班費用。</li>
                  </ul>
                  <div>不適用：
                    <ul>
                      <li>繳稅、繳罰單、勞保費、健保費、股票、國民年金、信用卡費、菸品、禮券、儲值與境外電商網站將不適用。</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q12</div>
                <div class="text">數位五倍券如何一起「共同綁定」？</div>
              </div>
              <div class="answer">
                <div class="text">
                  綁定時間：9/22~10/1<br>但若是反悔想退出，9/22~10/6中午12：00前，都能解除共同綁定<br>
                  <div class="my-8">同住家人如果不會，或不想操作數位綁定，可以由一人為代表，幫親友一起綁定數位五倍券，每人名下，最多可以綁定四人，共有兩種綁定方式。</div>
                  <div><i class="owl-caret-right"/>方法一：線上綁定</div>
                  <div class="ml-16">登入振興五倍券官網後，必須先完成身分認證（方法包含健保卡、健保快易通（OTP）、自然人憑證），接著，勾選要共同綁定的親友，確認後就完成綁定。</div>
                  <div><i class="owl-caret-right"/>方法二：前往超商綁定</div>
                  <div class="ml-16">至四大超商的事務機，進入五倍券專區後，點選「共同綁定」，接著依序插入要綁定親友的健保卡，最後再插入自己（主綁定人）的健保卡，確認後就能完成。</div>
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q13</div>
                <div class="text">如何在實體商家，證明我用的是數位五倍券？</div>
              </div>
              <div class="answer">
                <div class="text">今年在綁定數位五倍券後，會直接在綁定的平台網頁（銀行網頁、行動支付App等），產生一組代碼以及QR Code，如果是在電商消費，複製貼上代碼就能證明，該筆消費使用的是五倍券額度；若是實體商家，秀出QR Code讓商機掃描就可以，民眾若要知道5,000塊的額度還剩下多少，可以上銀行或是支付業者的官網查詢。</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q14</div>
                <div class="text">加碼券抽獎相關說明</div>
              </div>
              <div class="answer">
                <div class="text">
                  登記時間：9/22~10/29 23：59以前<br>
                  登記方式：身分證號+手機簡訊確認<br>
                  不論民眾是否已完成五倍券紙本預訂，或數位綁定所有人，都可以在開放登記的時間內，到振興五倍券官網上，直接勾選加碼券參與抽籤。<br>
                  主要分成兩種方式，在官網完成個人綁定、共同綁定或紙本預訂者，接續可於官網繼續勾選自己及共同綁定人參與抽籤之加碼券；若於超商事務機完成共同綁定者，可掃描超商小白單的QR Code，連結至五倍券官網，依序選擇自己及共同綁定人參與抽籤之加碼券種。<br>
                  各部會的加碼會在10月11日到11月5日之間，採4週抽籤，從面額小的抽到面額大的，每人每週最多中籤1次，等於4週最多可有4次中籤機會，每種券別僅可中籤一次，被抽到的民眾會收到簡訊通知。
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-green">Q15</div>
                <div class="text">五倍券可以找零嗎？</div>
              </div>
              <div class="answer">
                <div class="text">不能硬性要求商家找零，商家基於便利可找零。</div>
              </div>
            </div>
          </div>
        </div>
        <div id="anchor__revitalize__section02" class="faq">
          <div class="container container__810">
            <h3 class="mb-24 font-bold text-red">什麼是奧丁丁揪你？</h3>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-red">Q1</div>
                <div class="text">什麼是奧丁丁揪你？</div>
              </div>
              <div class="answer">
                <div class="text">奧丁丁集團旗下全新訂房網站 OwlJourney 奧丁丁揪你於 2019 年推出，彙整多年旅遊與旅宿經驗，結合多樣化旅程與豐富房源，提供一站式旅遊服務平台，以核心理念：精選、超值、安心為創站理念。<br>並推出全球最優惠活動－集滿5晚享第6晚半價，集滿8晚直接兌換免費住宿乙晚，住越多省越多。<br>訂購完成後更可享周邊體驗行程優惠折扣，讓消費者一站滿足旅程規劃！</div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-red">Q2</div>
                <div class="text">為什麼選奧丁丁揪你？</div>
              </div>
              <div class="answer">
                <div class="text">
                  <div>我們提供您三大承諾</div>
                  <ul class="list-reset font-bold">
                    <li>精選：內部審查人員，嚴格挑選房源</li>
                    <li>超值：全球最優惠，累積訂房免費入住</li>
                    <li>安心：推薦合法旅店與民宿，讓旅行者住得安心</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="question">
                <div class="mark text-red">Q3</div>
                <div class="text">奧丁丁揪你目前有什麼優惠活動？</div>
              </div>
              <div class="answer">
                <div class="text">奧丁丁揪你將不定期舉辦多種活動，主打「全球最優惠－集滿5晚享第6晚半價，集滿8晚直接兌換免費住宿乙晚」；另有邀請好友拿Coupon等活動，詳情請見<router-link :to="{name: 'Event',  params:{eventId: 'specialoffer'} }" class="text-red" target='_blank'>官網活動頁</router-link>。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="anchor__revitalize__section03" class="recommend">
        <div class="container">
          <div class="mx-auto text-center my-32" style="max-width: 485px;">
            <h2 class="font-bold mb-8">OwlJourney 全球最優惠</h2>
            <p class="text-lg font-bold leading-md">住5晚，第6晚半價；住8晚，享1晚免費住宿<br>揪你力挺振興五倍券！加碼最高折抵 1000元</p>
            <!-- <button class="btn btn-sm btn-solid btn-blue mx-8" @click="copyCoupon('OwlJourney', $event)">點我複製</button> -->
          </div>
          <div>
            <div class="recommend__title">全台旅宿專區</div>
            <div class="recommend__context">
              <div v-for="(location, index) in locationList.content" class="location__col" :key="location.id">
                <div class="location__col__cover__wrap" @click="onLocationClick(location)">
                  <div class="location__col__cover" :style="`backgroundImage: url('${location.cover}??lock=${index}');`"></div>
                </div>
                <div class="location__col__name" v-for="text in location.text" :key="text">{{ text }}</div>
              </div>
            </div>
          </div>
          <div v-for="(group, key) in hotels" :key="key">
            <div class="recommend__title">{{ key }}</div>
            <div class="recommend__context">
              <template v-for="hotel in group.hotels">
                <!-- <pre :key="index">{{ hotel }}</pre> -->
                <hotelCard
                  v-if="hotel.data"
                  class="w-1/2 md:w-1/3 lg:w-1/4"
                  :hotel="hotel.data"
                  :key="hotel.data.hotelUUID"
                  :isSavingBtn="false"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <travelFooter />
    <div v-show="isMobileMenu" class="mobileMenu__mask" @click="toggleMenu"></div>
    <div v-show="isMobileMenu" class="mobileMenu absolute top-0">
      <scrollactive
        :offset="40"
        :modifyUrl="false"
        :highlightFirstItem="false"
        class="mobileMenu__nav"
      >
        <a href="#anchor__revitalize__section01" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer" @click="toggleMenu">振興五倍券</a>
        <a href="#anchor__revitalize__section02" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer" @click="toggleMenu">什麼是奧丁丁揪你？</a>
        <a href="#anchor__revitalize__section03" class="px-8 no-underline text-grey-darkest hover:text-black ease scrollactive-item cursor-pointer" @click="toggleMenu">旅宿推薦</a>
      </scrollactive>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import HOTELS from '@/api/hotels'
import hotelCard from '@/components/hotelCard.vue'
import travelFooter from '@/layouts/travelFooter'
import clipboard from '@/utils/clipboard'
import mobileCover from '@/assets/revitalize/mobile.jpeg'
import desktopCover from '@/assets/revitalize/desktop.jpeg'

export default {
  name: 'Revitalize',
  metaInfo () {
    return {
      title: '一站秒懂「振興五倍券」最新資訊及如何使用',
      meta: [
        {
          'property': 'description',
          'template': `隨著去年(2020)年推出三倍券後，創造很大的經濟效益，今年(2021)推出振興五倍券，整體方案可較去年創造更大的振興效果，秉持著「更好領、更好用、更刺激」三大原則，來讓臺灣邁向新階段。自 9 月 22 日起開放數位五倍券綁定，並於 10 月 8 日正式開始消費累積。每人可換取 5000 元，分為紙本實體券、信用卡、電子票證及行動支付，四種領取方式任你挑選，效期使用至2022年4月30日止。`
        },
        {
          'property': 'og:title',
          'content': `一站秒懂「振興五倍券」最新資訊及如何使用`,
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'content': `隨著去年(2020)年推出三倍券後，創造很大的經濟效益，今年(2021)推出振興五倍券，整體方案可較去年創造更大的振興效果，秉持著「更好領、更好用、更刺激」三大原則，來讓臺灣邁向新階段。自 9 月 22 日起開放數位五倍券綁定，並於 10 月 8 日正式開始消費累積。每人可換取 5000 元，分為紙本實體券、信用卡、電子票證及行動支付，四種領取方式任你挑選，效期使用至2022年4月30日止。`,
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': window.location.origin + this.mobileCover,
          'vmid': 'og:image'
        },
        {
          'property': 'og:image:width',
          'content': '750',
          'vmid': 'og:image:width'
        },
        {
          'property': 'og:image:height',
          'content': '480',
          'vmid': 'og:image:height'
        }
      ],
      script: [
        {
          vmid: 'json-ld',
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': [
              {
                '@type': 'Question',
                'name': '五倍券是什麼？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '政府為了振興經濟，決定將比照去年三倍券模式發放「振興五倍券」，帶動國人消費。'
                }
              },
              {
                '@type': 'Question',
                'name': '誰能領五倍券？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '本次五倍券全民普發、不排富，2022年4月30日截止前出生的中華民國國民皆可領取（包括新生兒），且具有中華民國國籍的國民、取得永久居留權的外籍人士都可以領取。'
                }
              },
              {
                '@type': 'Question',
                'name': '五倍券可以領幾次？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '每人僅限領一次。'
                }
              },
              {
                '@type': 'Question',
                'name': '五倍券發行形式？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '分為紙本券與數位券兩種，紙本券則會發放3張1000元 ，2張500元 ，5張200元，數位券則可分為「行動支付」和「電子票證」，以及「信用卡」等幾種綁定方式。'
                }
              },
              {
                '@type': 'Question',
                'name': '五倍券發行時間？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '數位綁定：9月22日；紙本預約：9月25日(超商、官網)、10月4日(郵局)。領取使用：10月8日(數位、超商)、10月12日(郵局)。使用期限：111年4月30日前'
                }
              },
              {
                '@type': 'Question',
                'name': '什麼是奧丁丁揪你？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '奧丁丁集團旗下全新訂房網站 OwlJourney 奧丁丁揪你於 2019 年推出，彙整多年旅遊與旅宿經驗，結合多樣化旅程與豐富房源，提供一站式旅遊服務平台，以核心理念：精選、超值、安心為創站理念。並推出全球最優惠活動－集滿5晚享第6晚半價，集滿8晚直接兌換免費住宿乙晚，住越多省越多。 訂購完成後更可享周邊體驗行程優惠折扣，讓消費者一站滿足旅程規劃！'
                }
              },
              {
                '@type': 'Question',
                'name': '為什麼選奧丁丁揪你？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '我們提供您三大承諾 精選：內部審查人員，嚴格挑選房源 超值：全球最優惠，累積訂房免費入住 安心：推薦合法旅店與民宿，讓旅行者住得安心'
                }
              },
              {
                '@type': 'Question',
                'name': '奧丁丁揪你目前有什麼優惠活動？',
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': '奧丁丁揪你將不定期舉辦多種活動，主打「全球最優惠－集滿5晚享第6晚半價，集滿8晚直接兌換免費住宿乙晚」；另有邀請好友拿Coupon等活動，詳情請見官網活動頁。'
                }
              }
            ]
          }
        },
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: 'https://journey.owlting.com/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://journey.owlting.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string'
            }
          }
        }
      ]
    }
  },
  components: {
    hotelCard,
    travelFooter
  },
  data () {
    return {
      mobileCover: mobileCover,
      desktopCover: desktopCover,
      isMobileMenu: false,
      logoImg: require('@/assets/images/logos/logo-tw.svg'),
      location: {
        text: '台南市',
        key: 'tainan',
        subject: '台灣',
        subject_key: 'taiwan',
        hotels_count: 126,
        cover:
          'https://owlting-ota.s3.ap-northeast-1.amazonaws.com/images/stage/module/zGkTRrjYxrbuMjDsZJRQTGcPaGMoWhtc.jpg',
        type: 'city'
      },
      hotels: {
        '中部': {
          hotels: [
            {
              hotelUUID: 'b0bb3daa-1798-463a-9618-ba4955ef8aa6',
              price: 3116,
              data: null
            },
            {
              hotelUUID: 'd2037e06-6ddc-451b-97aa-3d570281e310',
              price: 1818,
              data: null
            },
            {
              hotelUUID: 'fac9e187-66d1-4f2c-899b-49a4341d6b2d',
              price: 1818,
              data: null
            },
            {
              hotelUUID: '8b7963fd-0805-44e2-912c-5b13567f4767',
              price: 2771,
              data: null
            },
          ]
        },
        '南部': {
          hotels: [
            {
              hotelUUID: 'af095451-5927-4856-a840-5bec94560c12',
              price: 2061,
              data: null
            },
            {
              hotelUUID: '13a06927-eb8e-44f7-95ae-4f31883921ff',
              price: 1628,
              data: null
            },
            {
              hotelUUID: '08038f7a-ad93-4e13-aada-d4d717026109',
              price: 2468,
              data: null
            },
            {
              hotelUUID: '4e5b6b7f-74ab-40f7-ab33-d9728c246544',
              price: 2762,
              data: null
            },
          ]
        },
        '東部': {
          hotels: [
            {
              hotelUUID: '9be79fca-b431-474d-af46-9b3e491d3cf5',
              price: 2035,
              data: null
            },
            {
              hotelUUID: '90a45394-842e-4311-80b5-1de79a9fcd55',
              price: 1981,
              data: null
            },
            {
              hotelUUID: '8bca65e4-a5bd-420b-92c3-46ba21ff6275',
              price: 1905,
              data: null
            },
            {
              hotelUUID: '66919e38-9f23-4d6a-b1a5-f46e66f8b28f',
              price: 1905,
              data: null
            },
          ]
        },
        '北部': {
          hotels: [
            {
              hotelUUID: '3261b015-d36a-4495-bb14-15a3a3789ae6',
              price: 779,
              data: null
            },
            {
              hotelUUID: '577eea6e-f8c4-47ac-a64f-8f75bd117ee1',
              price: 1039,
              data: null
            },
            {
              hotelUUID: 'd9280bbc-1a53-453b-ba40-9a6e1bd8b752',
              price: 2424,
              data: null
            },
            {
              hotelUUID: '0003e4f2-3eba-45c9-8d2c-8c368e34286a',
              price: 1281,
              data: null
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      structure: 'home/structure'
    }),
    locationList: function () {
      const locations = _.find(this.structure, {
        'type': 'location'
      })
      return locations ? locations.meta : []
    }
  },
  methods: {
    ...mapActions([
      'home/fetchStructure'
    ]),
    onLocationClick: function (location) {
      this.$router.push({
        name: 'HotelsList',
        query: {
          search: location.text[1],
          searchId: location.id[1],
          start: this.$dayjs().add(1, 'day').format('YYYY-MM-DD'),
          end: this.$dayjs().add(7, 'day').format('YYYY-MM-DD')
        }
      })
    },
    toggleMenu: function () {
      this.isMobileMenu = !this.isMobileMenu
    },
    copyCoupon: function (coupon, $event) {
      clipboard(coupon, $event, {
        success: `[${this.$t('couponHadBeenCopy')}] ${coupon}`
      })
    },
    getHotelByLoop: function () {
      const flatMap = _.flatMap(this.hotels, group => {
        return group.hotels
      })
      _.each(flatMap, ({ hotelUUID }) => {
        const groupIndex = _.findKey(this.hotels, function (group) {
          return _.findKey(group.hotels, ['hotelUUID', hotelUUID])
        })
        const hotelIndex = _.findIndex(this.hotels[groupIndex].hotels, ['hotelUUID', hotelUUID])
        const target = this.hotels[groupIndex].hotels[hotelIndex]
        HOTELS.getHotel(hotelUUID).then(res => {
          if (res.status === 200) {
            this.$set(target, 'data', _.chain(res.data).omit('tags').assign({ 'price': target.price, 'coverImage': res.data.coverImages[0] || null }).value())
          }
        })
      })
    }
  },
  created () {
    this['home/fetchStructure']()
    this.getHotelByLoop()
  }
}
</script>

<style lang="sass" scoped>
.revitalize
  &__header
    @apply bg-white shadow fixed w-full z-999
    @screen md
      @apply py-8
    &__logo
      @apply py-4
    &__nav
      a.is-active
        @apply text-blue
  &__body
    padding-top: 51px
    @screen md
      padding-top: 67px
    .container__810
      max-width: 810px
%dividing-line
  background:
      image: url("~@/assets/dividing_line.png")
      repeat: repeat-x
      position: top 0
.faq
  @apply bg-white
  @apply py-64
  &:not(:first-child)
    @extend %dividing-line
  .question
    @apply mt-8
    .mark
      @apply text-6xl font-bold mb-8
      @apply break-words leading-md
    .text
      @apply font-bold text-lg mb-8
      @apply break-words leading-md
  .answer
    @apply relative border border-grey-lighter rounded p-16
    @apply break-words leading-md text-sm
    @apply text-grey-darkest
    @apply mb-24
    top: 4px
    &:before
      content: ''
      position: absolute
      top: -9px
      left: 11px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 9px 9px 9px
      border-color: transparent transparent #ddd transparent
    &:after
      content: ''
      position: absolute
      top: -8px
      left: 12px
      width: 0
      height: 0
      border-style: solid
      border-width: 0 8px 8px 8px
      border-color: transparent transparent #fff transparent
.recommend
  @apply pt-32
  @extend %dividing-line
  &__title
    @apply text-xl font-bold mb-16
  &__context
    @apply flex flex-wrap mb-32
    @screen md
      @apply -mx-4

.location
  @apply mb-48
  @screen md
    @apply -mx-8
  &__col
    @apply relative text-center rounded-sm text-white p-8 flex items-center justify-center w-1/3 cursor-pointer
    @screen md
      @apply w-1/4
    @screen lg
      @apply w-1/6
    &__cover
      @apply w-full ease
      padding-top: imageRatio(233, 152)
      transform: scale(1.005)
      background:
        position: center
        repeat: no-repeat
        size: cover
      &:hover
        @apply shadow-md
        transform: scale(1.1)
      &__wrap
        @apply overflow-hidden rounded-sm w-full
    &__name
      @apply absolute text-lg font-bold
      bottom: 16px
      left: 16px
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.75)
      pointer-events: none
      &:not(:last-child)
        @apply hidden

.mobileMenu
  @apply fixed bg-white rounded shadow
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  &__nav
    @apply flex flex-col
    min-width: 300px
    a
      @apply p-16
      &:not(:last-child)
        @apply border-b border-grey-lighter
      &.is-active
        @apply text-blue
  &__mask
    @apply fixed
    top: 0
    left: 0
    width: 100%
    height: 100vh
    background: rgba(#000, .3)
.bg-blur
  background:
    size: cover
    position: center top
    repeat: no-repeat
  filter: blur(50px)
  -webkit-filter: blur(50px)
  opacity: .8
  overflow: hidden
.bg-mask
  background: rgb(255,255,255)
  background: -moz-linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.3) 35%, rgba(255,255,255,0) 100%)
  background: -webkit-linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.3) 35%, rgba(255,255,255,0) 100%)
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.3) 35%, rgba(255,255,255,0) 100%)
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1)
</style>
